import type { Cards } from '../../../../common/types.tsx';
import {
	TAILORED_ONBOARDING_SUMMARY,
	TAILORED_ONBOARDING_LIST,
	TAILORED_ONBOARDING_TIMELINE,
	TAILORED_ONBOARDING_PAGES,
	TAILORED_ONBOARDING_FORM,
	TAILORED_ONBOARDING_INVITE,
	TAILORED_ONBOARDING_BOARD,
	TAILORED_ONBOARDING_CALENDAR,
	TAILORED_ONBOARDING_CODE,
	TAILORED_ONBOARDING_BACKLOG,
} from '../../../../common/constants.tsx';
import { Feature, TeamType } from './constants.tsx';

export const TAILORED_ONBOARDING_SINGLE_CONFIG: Cards = {
	[TAILORED_ONBOARDING_SUMMARY]: {
		position: {
			default: 200,
			conditional: [
				{
					condition: [TeamType.marketing],
					value: 400,
				},
			],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Feature.hasBacklog, Feature.hasSprint],
					value: false,
				},
				{
					condition: [Feature.hasSummaryPage, TeamType.marketing],
					value: true,
				},
				{
					condition: [Feature.hasSummaryPage, TeamType.projectManagement],
					value: true,
				},
				{
					condition: [Feature.hasSummaryPage, TeamType.itSupport],
					value: true,
				},
				{
					condition: [Feature.hasSummaryPage, TeamType.operations],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_TIMELINE]: {
		position: {
			default: 0,
			conditional: [
				{
					condition: [TeamType.software, Feature.hasBacklog, Feature.hasSprint],
					value: 600,
				},
				{
					condition: [Feature.hasBacklog, Feature.hasSprint],
					value: 500,
				},
				{
					condition: [TeamType.software],
					value: 600,
				},
				{
					condition: [TeamType.marketing],
					value: 100,
				},
				{
					condition: [TeamType.productManagement],
					value: 200,
				},
				{
					condition: [TeamType.projectManagement],
					value: 100,
				},
				{
					condition: [TeamType.software],
					value: 400,
				},
				{
					condition: [TeamType.operations],
					value: 300,
				},
				{
					condition: [TeamType.everythingElse],
					value: 400,
				},
			],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Feature.hasBacklog, Feature.hasSprint, Feature.hasRoadmap],
					value: true,
				},
				{
					condition: [TeamType.marketing, Feature.hasRoadmap],
					value: true,
				},
				{
					condition: [TeamType.productManagement, Feature.hasRoadmap],
					value: true,
				},
				{
					condition: [TeamType.projectManagement, Feature.hasRoadmap],
					value: true,
				},
				{
					condition: [TeamType.software, Feature.hasRoadmap],
					value: true,
				},
				{
					condition: [TeamType.operations, Feature.hasRoadmap],
					value: true,
				},
				{
					condition: [TeamType.everythingElse, Feature.hasRoadmap],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_LIST]: {
		position: {
			default: 0,
			conditional: [],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Feature.hasBacklog, Feature.hasSprint, Feature.hasList],
					value: false,
				},
				{
					condition: [TeamType.marketing, Feature.hasList],
					value: true,
				},
				{
					condition: [TeamType.design, Feature.hasList],
					value: true,
				},
				{
					condition: [TeamType.productManagement, Feature.hasList],
					value: true,
				},
				{
					condition: [TeamType.projectManagement, Feature.hasList],
					value: true,
				},
				{
					condition: [TeamType.software, Feature.hasList],
					value: true,
				},
				{
					condition: [TeamType.otherPersonal, Feature.hasList],
					value: true,
				},
				{
					condition: [TeamType.itSupport, Feature.hasList],
					value: true,
				},
				{
					condition: [TeamType.operations, Feature.hasList],
					value: true,
				},
				{
					condition: [TeamType.everythingElse, Feature.hasList],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_BACKLOG]: {
		position: { default: 0 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Feature.hasBacklog, Feature.hasSprint],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_BOARD]: {
		position: {
			default: 100,
			conditional: [
				{
					condition: [Feature.hasBacklog, Feature.hasSprint],
					value: 100,
				},
				{
					condition: [TeamType.design],
					value: 400,
				},
				{
					condition: [TeamType.itSupport],
					value: 300,
				},
				{
					condition: [TeamType.operations],
					value: 100,
				},
				{
					condition: [TeamType.everythingElse],
					value: 100,
				},
			],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Feature.hasBacklog, Feature.hasSprint],
					value: true,
				},
				{
					condition: [TeamType.design],
					value: true,
				},
				{
					condition: [TeamType.software],
					value: true,
				},
				{
					condition: [TeamType.otherPersonal],
					value: true,
				},
				{
					condition: [TeamType.itSupport],
					value: true,
				},
				{
					condition: [TeamType.operations],
					value: true,
				},
				{
					condition: [TeamType.everythingElse],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_CALENDAR]: {
		position: {
			default: 300,
			conditional: [
				{
					condition: [Feature.hasBacklog, Feature.hasSprint],
					value: 300,
				},
				{
					condition: [TeamType.marketing],
					value: 100,
				},
				{
					condition: [TeamType.productManagement],
					value: 300,
				},
				{
					condition: [TeamType.projectManagement],
					value: 300,
				},
				{
					condition: [TeamType.software],
					value: 200,
				},
				{
					condition: [TeamType.itSupport],
					value: 500,
				},
				{
					condition: [TeamType.operations],
					value: 400,
				},
				{
					condition: [TeamType.everythingElse],
					value: 200,
				},
			],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [TeamType.software],
					value: false,
				},
				{
					condition: [Feature.hasBacklog, Feature.hasSprint, Feature.hasCalendar],
					value: true,
				},
				{
					condition: [TeamType.marketing, Feature.hasCalendar],
					value: true,
				},
				{
					condition: [TeamType.design, Feature.hasCalendar],
					value: true,
				},
				{
					condition: [TeamType.software, Feature.hasCalendar],
					value: true,
				},
				{
					condition: [TeamType.otherPersonal, Feature.hasCalendar],
					value: true,
				},
				{
					condition: [TeamType.itSupport, Feature.hasCalendar],
					value: true,
				},
				{
					condition: [TeamType.operations, Feature.hasCalendar],
					value: true,
				},
				{
					condition: [TeamType.everythingElse, Feature.hasCalendar],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_CODE]: {
		position: {
			default: 300,
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [TeamType.software, Feature.hasCode],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_PAGES]: {
		position: {
			default: 300,
			conditional: [
				{
					condition: [TeamType.software, Feature.hasBacklog, Feature.hasSprint],
					value: 400,
				},
				{
					condition: [Feature.hasBacklog, Feature.hasSprint],
					value: 500,
				},
				{
					condition: [TeamType.projectManagement],
					value: 500,
				},
				{
					condition: [TeamType.software],
					value: 500,
				},
				{
					condition: [TeamType.itSupport],
					value: 500,
				},
				{
					condition: [TeamType.everythingElse],
					value: 500,
				},
			],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Feature.hasBacklog, Feature.hasSprint, Feature.hasPages],
					value: true,
				},
				{
					condition: [TeamType.marketing, Feature.hasPages],
					value: true,
				},
				{
					condition: [TeamType.design, Feature.hasPages],
					value: true,
				},
				{
					condition: [TeamType.productManagement, Feature.hasPages],
					value: true,
				},
				{
					condition: [TeamType.projectManagement, Feature.hasPages],
					value: true,
				},
				{
					condition: [TeamType.software, Feature.hasPages],
					value: true,
				},
				{
					condition: [TeamType.otherPersonal, Feature.hasPages],
					value: true,
				},
				{
					condition: [TeamType.itSupport, Feature.hasPages],
					value: true,
				},
				{
					condition: [TeamType.operations, Feature.hasPages],
					value: false,
				},
				{
					condition: [TeamType.everythingElse, Feature.hasPages],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_FORM]: {
		position: {
			default: 500,
			conditional: [
				{
					condition: [Feature.hasBacklog, Feature.hasSprint],
					value: 500,
				},
				{
					condition: [TeamType.marketing],
					value: 400,
				},
				{
					condition: [TeamType.design],
					value: 300,
				},
				{
					condition: [TeamType.productManagement],
					value: 300,
				},
				{
					condition: [TeamType.projectManagement],
					value: 300,
				},
				{
					condition: [TeamType.itSupport],
					value: 400,
				},
			],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Feature.hasBacklog, Feature.hasSprint, Feature.hasForms],
					value: true,
				},
				{
					condition: [TeamType.design, Feature.hasForms],
					value: true,
				},
				{
					condition: [TeamType.productManagement, Feature.hasForms],
					value: true,
				},
				{
					condition: [TeamType.projectManagement, Feature.hasForms],
					value: true,
				},
				{
					condition: [TeamType.software, Feature.hasForms],
					value: true,
				},
				{
					condition: [TeamType.otherPersonal, Feature.hasForms],
					value: true,
				},
				{
					condition: [TeamType.itSupport, Feature.hasForms],
					value: true,
				},
				{
					condition: [TeamType.operations, Feature.hasForms],
					value: true,
				},
				{
					condition: [TeamType.everythingElse, Feature.hasForms],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_INVITE]: {
		position: {
			default: 500,
			conditional: [
				{
					condition: [Feature.hasBacklog, Feature.hasSprint],
					value: 700,
				},
				{
					condition: [TeamType.software],
					value: 700,
				},
			],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [Feature.hasBacklog, Feature.hasSprint],
					value: true,
				},
				{
					condition: [TeamType.marketing],
					value: true,
				},
				{
					condition: [TeamType.design],
					value: true,
				},
				{
					condition: [TeamType.productManagement],
					value: true,
				},
				{
					condition: [TeamType.projectManagement],
					value: true,
				},
				{
					condition: [TeamType.software],
					value: true,
				},
				{
					condition: [TeamType.otherPersonal],
					value: true,
				},
				{
					condition: [TeamType.itSupport],
					value: true,
				},
				{
					condition: [TeamType.operations],
					value: true,
				},
				{
					condition: [TeamType.everythingElse],
					value: true,
				},
			],
		},
	},
};
